import { z } from 'zod';

export const OPS_INCIDENT_KEYS = ['shop-db-reads', 'quo-credits'] as const;
export type OpsIncidentKey = (typeof OPS_INCIDENT_KEYS)[number];

export const InboxNoticeSchema = z.object({
  key: z.enum(OPS_INCIDENT_KEYS),
  failingSince: z.iso.datetime(),
});
export type InboxNotice = z.infer<typeof InboxNoticeSchema>;

export const InboxNoticesResponseSchema = z.object({
  notices: z.array(InboxNoticeSchema),
});
export type InboxNoticesResponse = z.infer<typeof InboxNoticesResponseSchema>;
